import {styled} from "@mui/material";

export const InfoContainer = styled("div")(({theme}) => ({
    marginBottom: "50px",
}));

interface titleContainerInterface {
    secondaryTitle?: boolean;
}

export const TitleContainer = styled("div")<titleContainerInterface>(({theme, secondaryTitle}) => ({
    display: "flex",
    // marginRight: secondaryTitle ? 0 : -40,
    height: "40px",
    marginBottom: "30px",
    alignItems: "center",
}));
